import { ACADEMY_NAV_SECTIONS } from '@common/components/MobileMenu/variants/AcademyMobileMenu/academy-mobile-menu.const'
import type {
  AcademyNavItem,
  AcademyNavItemId,
} from '@common/components/MobileMenu/variants/AcademyMobileMenu/academy-mobile-menu.interface'

import { DOCS_ROUTES } from '@/shared/docs-shared.const'
import { getAcademyExternalUrl, isDocumentationPath } from '@/shared/docs-shared.utils'

export { ACADEMY_NAV_SECTIONS }

export function getAcademyBaseUrl(): string {
  return getAcademyExternalUrl()
}

export function getDocsSidebarNavUrl(item: AcademyNavItem): string {
  const academyUrl = getAcademyBaseUrl()

  switch (item.id) {
    case 'home':
      return academyUrl
    case 'documentation':
      return '/'
    case 'quickStart':
      return DOCS_ROUTES.quickStart
    case 'glossary':
      return `${academyUrl}/glossary`
    case 'codeSandbox':
      return `${academyUrl}/code-sandbox`
    default:
      return item.path
  }
}

export function isDocsSidebarNavItemActive(itemId: AcademyNavItemId, pathname: string): boolean {
  const path = pathname.split('?')[0] || ''

  if (itemId === 'documentation') {
    return isDocumentationPath(path) || path === '/'
  }

  if (itemId === 'quickStart') {
    return path.startsWith(DOCS_ROUTES.quickStart)
  }

  return false
}
